export default {
  ACCEPT_POLICY: 'cookie_accept_policy',
  CARDAN_TRACK_MENU: 'cardan',
  CUSTOMER_ID: 'stwu',
  CUSTOMER_TEMP_ID: 'stwt',
  GA_ADD_TO_CART: 'ga_cookie_add',
  GATEKEEPER_EXHIBITION: "gatekeeper_exhibition",
  ML_EXP: 'ml_exp',
  ML2_SID: "ml2_sid",
  ML2_SID_C: "ml2_sid_c",
  ML2_TID: "ml_tid",
  MLPARCEIRO: "MLPARCEIRO",
  PAGE_BEFORE_LOGIN: "page_before_login",
  PMD_SHAREDBAG: "pmd_sharedbag",
  REJECT_ZIPCODE_POPUP: 'cookie_reject_zipcode_popup',
  SHOW_SELLER_SCORE_ABOVE: 'show_seller_score_above',
  TOGGLE_NEW_SERVICE_PAGE_SPA: 'toggle_new_service_page_spa',
  WHATSAPP_TEXT: 'whatsapp_text',
  ZIPCODE: "zipcode",
  ZIPCODE_CHECKSUM: "zipcode_checksum",
  ZIPCODE_CITY: "zipcode_city",
  ZIPCODE_LATITUDE: "zipcode_latitude",
  ZIPCODE_LONGITUDE: "zipcode_longitude",
  ZIPCODE_STATE: "zipcode_state"
};